import React, {Component} from "react";
import "./Docs.css";
import FeaturedListItem from "../../common/FeaturedListItem";
import {Link} from "react-router";
import AnchorLink from "../../common/AnchorLink";

class BotIndex extends Component {
    render() {
        return (
            <div className="container">
                <div className="row m-b-sm">
                    <div className="col-lg-12">
                        <h1 className="page-header">Help &amp; support</h1>
                        <p>Choose a section for more information.</p>
                    </div>
                </div>

                <div className="row m-b-sm">
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <Link className="btn btn-lg btn-info btn-info-outline btn-block"
                              to="/docs/bot/getting-started">Getting started</Link>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="tutorials">Tutorials</AnchorLink>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="config">Configuration</AnchorLink>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="general">General</AnchorLink>
                    </div>
                </div>

                <section id="tutorials">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">Tutorials</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="FAQs" icon="help" linkText="Learn more" linkTo="/docs/bot/faq">
                            Frequently asked questions.
                        </FeaturedListItem>

                        <FeaturedListItem title="Getting Started" icon="address" linkText="Let's go!" linkTo="/docs/bot/getting-started">
                            This guide will help you get up and running quickly.
                        </FeaturedListItem>
                    </div>
                </section>

                <section id="config">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">Configuration</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Connections" icon="power-plug" linkText="Learn more" linkTo="/docs/bot/connections">
                            Connect your bot to services like Slack, Jenkins and Rundeck.
                        </FeaturedListItem>

                        <FeaturedListItem title="Actions" icon="rocket" linkText="Learn more" linkTo="/docs/bot/actions">
                            How your bot responds to your messages. Add actions to trigger your jobs and any
                            parameters they require. Learn more and see our samples.
                        </FeaturedListItem>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Build systems" icon="tools" linkText="Learn more" linkTo="/docs/bot/build-systems">
                            We work with the tools teams use every day to build and deploy software,
                            like Jenkins and Rundeck.
                        </FeaturedListItem>

                        <FeaturedListItem title="Security" icon="key" linkText="Learn more" linkTo="/docs/bot/action-security">
                            Lock and unlock jobs. Control who has access to performs certain actions
                            and on which jobs.
                        </FeaturedListItem>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Samples" icon="text-document" linkText="View samples" linkTo="/docs/bot/samples">
                            Looking for inspiration? Just getting started? Check out our samples.
                        </FeaturedListItem>
                    </div>
                </section>

                <section id="general">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">General</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Platform" icon="drive" linkText="Learn more" linkTo="/docs/platform">
                            We process requests across a self-healing network of reliable servers to
                            ensure great uptime, always.
                        </FeaturedListItem>
                        <FeaturedListItem title="About us" icon="heart" linkText="Learn more" linkTo="/docs/about">
                            Learn more about us.
                        </FeaturedListItem>
                    </div>
                </section>
            </div>
        );
    }
}

export default BotIndex;



// WEBPACK FOOTER //
// ./src/modules/views/docs/BotIndex.js